exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fade-enter-active[data-v-5474d03e],.fade-leave-active[data-v-5474d03e]{\n  -webkit-transition:all .5s ease;\n  transition:all .5s ease;\n  overflow:hidden\n}\n.fade-enter[data-v-5474d03e],.fade-leave-to[data-v-5474d03e]{\n  opacity:0\n}", ""]);

// exports
